import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ProfileComponent } from './profile/profile.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { ServerErrorComponent } from './server-error/server-error.component';
import { HeaderModule } from '../header/header.module';
import { NoPermissionComponent } from './no-permission/no-permission.component';
import { TermsOfUseComponent } from './terms-of-use/terms-of-use.component';
import { FaqComponent } from './faq/faq.component';
import { LoginModule } from '../login/login.module';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { LoadingComponent } from './loading/loading.component';
import { RouterModule } from '@angular/router';


@NgModule({
  declarations: [
    ProfileComponent,
    NotFoundComponent,
    ServerErrorComponent,
    NoPermissionComponent,
    TermsOfUseComponent,
    FaqComponent,
    PrivacyPolicyComponent,
    LoadingComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    FormsModule,
    NgbModule,
    ReactiveFormsModule,
    HeaderModule,
    LoginModule, RouterModule
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule
  ]
})
export class UserModule { }
